import { AlertColor, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDrop } from 'react-dnd';
import { useDispatch } from 'react-redux';
import ShortUniqueId from 'short-unique-id';
import { updateFilter } from '../../../redux/Calculations/CalculationsActions';
import { NotificationDialog } from '../../CommonFunctions/DialogComponents';
interface IFilterOverrideDropZone {
  children: React.ReactNode;
  propKey: string;
}
function FilterOverrideDropZone({ children, propKey }: IFilterOverrideDropZone) {
  const uid = new ShortUniqueId({ length: 4 });
  const [showBorder, setShowBorder] = useState(false);
  const dispatch = useDispatch();
   const [alert, setAlert] = useState<{
      severity: AlertColor;
      message: string;
    } | null>(null);
  const [{ isOver }, drop] = useDrop({
    accept: ['card', 'calculation'],
    hover: (item: any, monitor) => {
      if (monitor.isOver({ shallow: true }) && !showBorder) {
        setShowBorder(true);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
    drop: (item: any, monitor) => {
      const fieldId = uid();
      const { dataType, displayname, fieldname, tableId } = item.fieldData;
      if (item.fieldData.isAggregated) {
        setAlert({
          severity: 'warning',
          message: 'Aggregated fields cannot be added as override filters.',
        });
        setShowBorder(false);
        return;
      }
      const fieldInfo = {
        customization: false,
        uid: fieldId as string,
        dataType: dataType as string,
        displayName: displayname as string,
        fieldName: fieldname as string,
        tableId: tableId as string,
        timeGrain: 'year',
        ...(item.boxUUID
          ? {
              isCalculatedField: true,
              calculatedFieldId: item.boxUUID,
            }
          : {}),
      };
      dispatch(updateFilter(propKey, fieldId, 'add', fieldInfo));
      setShowBorder(false);
    },
  });
  useEffect(() => {
    if (!isOver) {
      setShowBorder(false);
    }
  }, [isOver]);
  return (
    <>
      {alert && (
        <NotificationDialog
          severity={alert.severity}
          openAlert={!!alert}
          onCloseAlert={() => setAlert(null)}
          testMessage={alert.message}
        />
      )}
      <Box
        id="filter-override-dropzone"
        ref={drop}
        className={`dropzone ${showBorder ? 'dropzone-highlighted' : ''}`}
        sx={{
          textAlign: 'left',
          // paddingBottom: '2rem',
          border: '1px solid transparent',
          height: 'fit-content',
          flexGrow: 1,
          mt: 1,
        }}
      >
        {children}
      </Box>
    </>
  );
}

export default FilterOverrideDropZone;
